import axios, { AxiosInstance } from 'axios';
import { showToast } from '@/shares/feedback/showToast';
const HOST_API = process.env.NEXT_PUBLIC_TOMARKET_HOST_API;

const request: AxiosInstance = axios.create({
  baseURL: HOST_API,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    // 'x-hack-user': 2
    // token: '', //钱包id
    // language: 'en', //语言
    // currency: '', //货币单位
    // apiBrand: 'web',
    // os: '',
    // package: '',
    // im: '',
    // timezonename: 0 - new Date().getTimezoneOffset() / 60, //时区
    // markethour: 'hour',
  },
});

request.interceptors.response.use(
  response => {
    const { status, message, data } = response.data;

    if (status === 0) {
      return data;
    } else {
      return Promise.reject(new Error(message || 'request failed'));
    }
  },
  error => {
    if ([429, 503].includes(error?.status)) {
      const msg = 'Network congested, try again later';
      showToast('none', msg);
      return Promise.reject(new Error(msg));
    }
    if (error.response) {
      const { message } = error.response;
      const msg = message || 'request failed';
      showToast('none', msg);
      return Promise.reject(new Error(msg));
    }

    return Promise.reject(new Error('Network Error'));
  }
);

export const getUserBgwAddressForm = {
  fetcher: ({ address }: { address: string }) =>
    request(`/tomarket-game/v1/tasks/getUserBgwAddressForm`, {
      method: 'post',
      data: {
        address,
      },
    }),
  key: 'getUserBgwAddressForm',
};

export const fillUserBgwAddressForm = {
  fetcher: ({ address, code }: { address: string; code: string }) =>
    request(`/tomarket-game/v1/tasks/fillUserBgwAddressForm`, {
      method: 'post',
      data: {
        address,
        code,
      },
    }),
  key: 'fillUserBgwAddressForm',
};

export const getAirdropResult = {
  fetcher: ({ address }: { address: string }) =>
    request(`/tomarket-game/v1/tasks/getBgwResult`, {
      method: 'post',
      data: {
        address,
      },
    }),
  key: 'getAirdropResult',
};
